import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type buyUpEligibilityUpdatePayloadType = {
	group_number: number;
	employee_SSN: string;
	buy_up_eligibility: boolean;
};

const initialRoute = "auth";

export const buyUpEligibilityUpdate = async (buyUpEligibilityUpdatePayload: buyUpEligibilityUpdatePayloadType) => {
	try {
		const payload = JSON.stringify(buyUpEligibilityUpdatePayload);
		const endpoint = `${initialRoute}/buy-up-eligibility-update`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				// const {
				// 	data: { result }
				// } = response;
				return message;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
